import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	sprintStarted: {
		id: 'software-burnup-report.chart.tooltip.sprint-started',
		defaultMessage: 'Sprint started',
		description: 'Tooltip message for the sprint start event in burnup',
	},
	sprintEnded: {
		id: 'software-burnup-report.chart.tooltip.sprint-ended',
		defaultMessage: 'Sprint ended',
		description: 'Tooltip message for the sprint end event in burnup',
	},
	statisticOriginalEstimate: {
		id: 'software-burnup-report.chart.tooltip.statistic-original-estimate',
		defaultMessage: 'Original estimate',
		description: 'Original estimate tooltip in burnup',
	},
});

export default messages;
